import Button from "components/Button/Button";
import { menuRow, MenuRowProps } from "styles/rowStyles";
import styled from "styled-components";

export const StepsList = styled.ol`
  width: 100%;
  max-width: 560px;
  margin: 20px auto 8px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StepButton = styled.button<MenuRowProps>`
  ${menuRow}
  gap: 12px;
`;

export const StepStatic = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  color: ${({ theme }) => theme.black};
`;

export const StepBubble = styled.span<{ $done?: boolean }>`
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  background-color: ${({ theme }) => theme.primary10};
  color: ${({ theme, $done }) => ($done ? theme.green : theme.accentText)};
`;

export const StepText = styled.span`
  font-size: 14px;
  line-height: 20px;
`;

export const OpenDetailsButton = styled(Button)`
  margin-top: 10px;
`;

export const BackButton = styled(Button)`
  display: block;
  margin: 0 auto 20px;
`;
